/* eslint-disable import/prefer-default-export */
import { getVisiblePhone } from './getVisiblePhone';

export const getMaskedPhone = ({
  phone,
  user,
  masked = true
}) => (masked
  ? getVisiblePhone({ phone, user })
  : phone);
